import React, { useCallback } from 'react';
import { Avatar, Checkbox, Tooltip } from 'antd';
import moment from 'moment';
import classNames from 'classnames';
import { AWAssetDto, MemberUserDto } from '@api/Api';
import UpgradePlanTooltip from '@components/Tooltip/UpgradePlanTooltip';
import { assetPreviewThumbnails } from '@helpers/assetPreviewThumbnails';
import { hashedColor } from '@helpers/hashedColor';
import UserAvatarLetters from '@helpers/userAvatarLetters';
import Loader from '@components/Loader';
import './AssetRow.less';
import timeLineFromNow from '@components/CampaignTimeline/utils';
import { WarningIcon } from '@icons';

export type AssetRowProps = {
  modifiedAt: string;
  createdAt: string;
  asset: AWAssetDto;
  user?: MemberUserDto | null;
  canSelectAsset: boolean;
  isSelected: boolean;
  hasActiveAW: boolean;
  onToggleSelectAsset: (asset: AWAssetDto, isSelected: boolean) => void;
};

export default function AssetRow({
  createdAt,
  asset,
  user,
  modifiedAt,
  isSelected,
  hasActiveAW,
  canSelectAsset,
  onToggleSelectAsset
}: AssetRowProps) {
  const isDisabled = !canSelectAsset && !isSelected;
  const modifiedTimeFromNow = timeLineFromNow(modifiedAt);

  const preview = useCallback(() => {
    return assetPreviewThumbnails({
      url: asset.previewUrl || '',
      status: 'ready',
      type: asset.type,
      size: 40,
      format: 'svg'
    });
  }, [asset.type, asset.previewUrl])();
  return (
    <div
      className={classNames('asset-row', {
        'b-has-active-aw': hasActiveAW
      })}
    >
      <UpgradePlanTooltip
        text=" to a Enterprise plan to access this feature"
        placement="top"
        isCanVisible={isDisabled}
      >
        <Checkbox
          value={asset.id}
          checked={isSelected}
          disabled={isDisabled}
          className="create-approval_checkbox"
          onChange={() => !isDisabled && onToggleSelectAsset(asset, isSelected)}
        />
      </UpgradePlanTooltip>

      <div className="asset-row-img">
        {preview === 'pending' && <Loader spinSize={32} isSpinning={true} />}
        {preview !== 'pending' ? (
          typeof preview === 'string' ? (
            <img src={preview || ''} alt="" />
          ) : (
            preview
          )
        ) : null}
      </div>
      <div className="asset-row-info">
        <div className="asset-row-name">
          <Tooltip
            title={`${asset.name}.${asset.extension}`}
            overlayClassName="approval-modal-tooltip"
            className="asset-row-asset-name"
          >
            {asset.name}.
          </Tooltip>
          {asset.extension}
          <div className="asset-row-version">V{asset.versionsCount}</div>
        </div>
        {hasActiveAW && <div className="asset-row_label">In review</div>}
      </div>
      <Tooltip
        title={user?.name}
        placement="bottom"
        overlayClassName="toggle_favorite_overlay"
      >
        <div className="asset-row-avatar">
          <Avatar
            src={user?.picture.url}
            size={24}
            style={{
              color: '#161819',
              fontWeight: 'bold',
              backgroundColor: hashedColor(
                user?.email ?? '',
                'mediaViewerComment'
              )
            }}
          >
            {UserAvatarLetters(user?.name)}
          </Avatar>
        </div>
      </Tooltip>
      <div className="asset-row-date">
        {moment(createdAt).format('MMM DD, YYYY')}
      </div>
      <Tooltip
        title={`Last updated ${modifiedTimeFromNow}`}
        overlayClassName="approval-modal-tooltip"
      >
        <div className="asset-row-date">{modifiedTimeFromNow}</div>
      </Tooltip>
      <div className="asset-row-text">
        {hasActiveAW && (
          <>
            <WarningIcon />
            In active approval routing
          </>
        )}
      </div>
    </div>
  );
}
